import React from "react";
import RegisterForm from "../components/Forms/RegisterForm";
import { Link } from "react-router-dom";

function RegisterPage() {
    return (
        <>
            <Link to="/login">Войти</Link>
            <RegisterForm></RegisterForm>
        </>
    );
}

export default RegisterPage;
